import { pdfjs } from "react-pdf";

const MIN_TEXT_LENGTH = 250;

export async function extractTextFromPdf(file: File): Promise<string | null> {
  try {
    const buffer = await file.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data: buffer }).promise;
    const pagePromises = Array.from({ length: pdf.numPages }, async (_, i) => {
      const page = await pdf.getPage(i + 1);
      const textContent = await page.getTextContent();
      return textContent.items
        .filter((item) => "str" in item && item.str)
        .map((item) => (item as { str: string }).str)
        .join(" ");
    });

    const fullText = (await Promise.all(pagePromises)).filter((t) => t.trim()).join("\n\n");

    if (fullText.length < MIN_TEXT_LENGTH) {
      return null;
    }

    return fullText;
  } catch (error) {
    console.error("PDF text extraction failed:", error);
    return null;
  }
}
